import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-6ba5f56c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "navigation-bg"
};
import { useRouter, useRoute } from 'vue-router';

import { inject, onMounted } from 'vue';
export default {
  __name: 'navigation',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const $screenWidth = inject('$screenWidth');
    const $screenSize = inject('$screenSize');
    onMounted(() => {
      console.log('$screenWidth', $screenWidth);
      console.log('$screenSize', $screenSize);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("img", {
        class: "logo",
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('/mainPage'))
      })]), _createElementVNode("li", {
        class: _normalizeClass(_ctx.$route.meta.activeNav == 'mainPage' ? 'active' : ''),
        onClick: _cache[1] || (_cache[1] = $event => _unref(router).push('/mainPage'))
      }, "首页", 2), _createElementVNode("li", {
        class: _normalizeClass(_ctx.$route.meta.activeNav == 'productCenter' ? 'active' : ''),
        onClick: _cache[2] || (_cache[2] = $event => _unref(router).push('/productCenter'))
      }, "产品中心", 2), _createElementVNode("li", {
        class: _normalizeClass(_ctx.$route.meta.activeNav == 'solution' ? 'active' : ''),
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push('/solution'))
      }, "解决方案", 2), _createElementVNode("li", {
        class: _normalizeClass(_ctx.$route.meta.activeNav == 'aboutUs' ? 'active' : ''),
        onClick: _cache[4] || (_cache[4] = $event => _unref(router).push('/aboutUs'))
      }, "关于我们", 2)])]);
    };
  }
};